import { Typography, useDeviceType } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { PeriodToggle } from './PeriodToggle';

type TPeriodProps = {
  yearlySelected: boolean;
  onToggle: (yearlySelected: boolean) => void;
};

export { PeriodToggle } from './PeriodToggle';

export const BillingPeriodTabs = ({ yearlySelected, onToggle }: TPeriodProps) => {
  const { isMobile } = useDeviceType();

  return (
    <Stack alignItems="center" direction="row" gap={12} justifyContent="center">
      <PeriodToggle yearlySelected={yearlySelected} onToggle={onToggle} />
      {!isMobile && (
        <Typography color="primary.500" variant="body-2-md">
          Save up to 50%
        </Typography>
      )}
    </Stack>
  );
};
